/** @hidden */
export var PropertyClass;
(function (PropertyClass) {
    PropertyClass["Fill"] = "Fill";
    PropertyClass["Color"] = "Color";
    PropertyClass["Gradient"] = "Gradient";
    PropertyClass["Shadow"] = "Shadow";
    PropertyClass["Stroke"] = "Stroke";
    PropertyClass["Pattern"] = "Pattern";
})(PropertyClass || (PropertyClass = {}));
export * from './color/types';
export * from './fill/types';
export * from './gradient/types';
export * from './pattern/types';
export * from './shadow/types';
export * from './stroke/types';
